module.exports = __webpack_public_path__ + "img/Banner_R&C.22d857d6.png";